import { Subscription } from 'core/subscription';
import { gql } from 'graphql-tag';

export const CONTRIBUTIONS_SUBSCRIPTION = gql`
  subscription ContributionsSubscription(
    $input: SubscribeProjectContributionInput!
  ) {
    projectContribution(input: $input) {
      id
    }
  }
`;

export class ContributionsSubscription extends Subscription {
  static conf = {
    GQL: CONTRIBUTIONS_SUBSCRIPTION,
    resultPath: 'projectContribution',
  };
}
